const BASE_API_ENDPOINT = '/api/v1';

export const CSV_UPLOAD_ENDPOINTS = {
  TYPE_OF_PURCHASE: `${BASE_API_ENDPOINT}/typeOfPurchases`,
  ADVERTISERS: `${BASE_API_ENDPOINT}/advertisers`,
  CATEGORIES: `${BASE_API_ENDPOINT}/categories`,
  ACCOUNT_EXECUTIVES: `${BASE_API_ENDPOINT}/users/accountExecutives`,
  CONTEXTUAL: `${BASE_API_ENDPOINT}/inventory/upload/contextual?artEventId=`,
  NON_CONTEXTUAL: `${BASE_API_ENDPOINT}/inventory/upload/noncontextual?artEventId=`,
};
